import { monitorValue } from "../../util/monitorUtils";

const buildBrakeData = (monitor) => {

    const result = {};

    const carsWithCompressor = [2, 3, 6, 7];

    for (let car = 1; car <= 8; car++) {
        const compressorCar =
            car === 2 || car === 3
                ? 3
                : car === 6 || car === 7
                    ? 7
                    : car;

        const items = [

            {
                label: "ISOLADO",
                active:
                    monitorValue(
                        monitor,
                        `isoladoCarro${car}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[`isoladoCarro${car}`]?.category
            },

            {
                label: "FALHA MAIOR BCE",
                active:
                    monitorValue(
                        monitor,
                        `falhaMaiorBceCarro${car}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[`isoladoCarro${car}`]?.category
            },

            {
                label: "FALHA MENOR BCE",
                active:
                    monitorValue(
                        monitor,
                        `falhaMenorBceCarro${car}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[`isoladoCarro${car}`]?.category
            },

            {
                label: "FALHA NA APLICAÇÃO",
                active:
                    monitorValue(
                        monitor,
                        `falhaAplicacaoCarro${car}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[`isoladoCarro${car}`]?.category
            },

            {
                label: "FALHA NA LIBERAÇÃO",
                active:
                    monitorValue(
                        monitor,
                        `falhaLiberacaoCarro${car}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[`isoladoCarro${car}`]?.category
            },

            {
                label: "BAIXA PRESSÃO",
                active:
                    monitorValue(
                        monitor,
                        `baixaPressaoCarro${car}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[`isoladoCarro${car}`]?.category
            },

            {
                label: "VALOR DA PRESSÃO",

                value: monitorValue(
                    monitor,
                    `valorPressaoCarro${car}`,
                    0
                ),

                active:
                    monitorValue(
                        monitor,
                        `valorPressaoCarro${car}`,
                        0
                    ) > 0,

                category:
                    monitor?.[
                        `valorPressaoCarro${car}`
                    ]?.category,

                isNumeric: true
            }
        ];

        if (carsWithCompressor.includes(car)) {

            items.push({
                label: "FALHA COMPRESSOR",
                active:
                    monitorValue(
                        monitor,
                        `falhaCompressorCarro${compressorCar}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[
                        `falhaCompressorCarro${compressorCar}`
                    ]?.category
            });

            items.push({
                label: "FALHA REQUISIÇÃO COMPRESSOR",
                active:
                    monitorValue(
                        monitor,
                        `falhaReqCompressorCarro${compressorCar}`,
                        0
                    ) !== 0,
                category:
                    monitor?.[
                        `falhaReqCompressorCarro${compressorCar}`
                    ]?.category
            });
        }

        result[car] = items;
    }

    return result;
};

export default buildBrakeData;